import updatesJson from './updates.json';
import { parseProductUpdates, type ProductUpdate } from './parseProductUpdates';

export const PRODUCT_UPDATES: readonly ProductUpdate[] =
  parseProductUpdates(updatesJson);
